import { fetchUtils } from '../utils/fetchUtils';

export const applyToJob = (jobId) => fetchUtils.post(`/api/applications/apply/${jobId}`);
export const getCandidateApplications = () => fetchUtils.get('/api/applications/candidate');
export const getJobApplications = (jobId) => fetchUtils.get(`/api/applications/job/${jobId}`);
export const updateApplicationStatus = (appId, status) => fetchUtils.put(`/api/applications/${appId}/status`, {}, { status });
